export enum OMNI_CHANNEL_EVENT {
  START = 'START',
  DIALING = 'DIALING',
  DIALANSWER = 'DIALANSWER',
  HANGUP = 'HANGUP',
  CDR = 'CDR',
  TRIM = 'TRIM',
  PBXCDR = 'PBXCDR',
  GET_CALL_DETAILS = 'GET_CALL_DETAILS',
  UPDATE_TOKEN = 'update_token',
  TOKEN_EXPIRED = 'token_expired',
  UNAUTHORIZED = 'unauthorized',
  JOIN_CHAT_SESSION = 'JOIN_CHAT_SESSION',
  LEAVE_CHAT_SESSION = 'LEAVE_CHAT_SESSION',
  ADD_CHAT_SESSION_WAITING = 'ADD_CHAT_SESSION_WAITING',
  REMOVE_CHAT_SESSION_WAITING = 'REMOVE_CHAT_SESSION_WAITING',
  CHAT_SESSION_PROCESSING = 'CHAT_SESSION_PROCESSING',
  MESSAGE = 'MESSAGE',
  GET_WAITING_CALLS = 'GET_WAITING_CALLS',
  UPDATE_CHAT_STAT_DETAILS = 'UPDATE_CHAT_STAT_DETAILS',
  UPDATE_CALL_STAT_DETAILS = 'UPDATE_CALL_STAT_DETAILS',

  AGENT_COUNTER_UPDATE = 'UPDATE_TOTAL_CALL_AND_CHAT_COUNTER',
  UPDATE_AGENT_MAP_SEAT = 'UPDATE_AGENT_MAP_SEAT',

  ADD_CHAT_IN_PROGRESS = 'ADD_CHAT_IN_PROGRESS',
  REMOVE_CHAT_IN_PROGRESS = 'REMOVE_CHAT_IN_PROGRESS',

  ADD_CHAT_AI_IN_PROGRESS = 'ADD_CHAT_AI_IN_PROGRESS',
  REMOVE_CHAT_AI_IN_PROGRESS = 'REMOVE_CHAT_AI_IN_PROGRESS',

  // chat monitoring user

  ADD_CHAT_MONITORING = 'ADD_CHAT_MONITORING',
  REMOVE_CHAT_MONITORING = 'REMOVE_CHAT_MONITORING',
  START_CHAT_MONITORING = 'START_CHAT_MONITORING',
  LEAVE_CHAT_MONITORING = 'LEAVE_CHAT_MONITORING',
  NEW_TICKET_INFO = 'NEW_TICKET_INFO',

  // call session

  JOIN_CALL_SESSION_AI = 'JOIN_CALL_SESSION_AI',
  LEAVE_CALL_SESSION_AI = 'LEAVE_CALL_SESSION_AI',
  CALL_SESSION_AI_PROCESSING = 'CALL_SESSION_AI_PROCESSING',
  SPEAK_TO_TEXT = 'SPEAK_TO_TEXT',

  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  CONNECT_ERROR = 'connect_error',
  ERROR = 'error',
  EXCEPTION = 'exception'
}
